import React, { useEffect, useState } from 'react'
import axios from "axios";
import { Button, Form, Input, Select, Checkbox, Upload, Switch, Spin } from "antd";
import { UploadOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useForm } from "antd/es/form/Form";
import { useNavigate, useLocation } from "react-router-dom";
import './PermitMasterDetail.css';
import moment from 'moment';
import { toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";
import { usePermitStore } from "../../Store/store";
import { useQueryClient } from '@tanstack/react-query';
const { TextArea } = Input;
const allowedTypes = ['image/png', 'image/jpeg', 'application/x-jhj']; // Add the MIME type for JHJ if applicable

const PermitMasterDetail = () => {
    const Navigate = useNavigate();
    const { state, pathname } = useLocation();
    const [PermiMasterInsert] = useForm();
    const [BasicPermitInsertForm] = useForm();
    const [UserDetails, setUserDetails] = useState({})
    const [PermitMasterMenu, setPermitMasterMenu] = useState([])
    const ExportBasicDetail = usePermitStore((state) => state.ExportBasicDetail);
    const ExportPermitDetail = usePermitStore((state) => state.ExportPermitDetail)
    const ExportPermitImgDetail = usePermitStore((state) => state.ExportPermitImgDetail);
    const [PermitMaterDetail, setPermitMaterDetail] = useState([])
    const [SelectPermitId, setSelectPermitId] = useState(0)
    const [LoaderHiden, setLoaderHiden] = useState(false)
    const [FileLists, setFileList] = useState([])
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        setUserDetails(JSON.parse(sessionStorage.getItem("UserInfo")))
        getBasicPermitView()
        getPermitMasterMenu(JSON.parse(sessionStorage.getItem("UserInfo")))
    }, []);

    useEffect(() => {
        if (state === "Edit") {
            var permit = ExportPermitDetail;
            setPermitMaterDetail(permit)
            var Images = [];
            Images = ExportPermitImgDetail.images
            let URL = process.env.REACT_APP_PERMIT + "/Master/DownloadImage"
            axios.post(URL, Images).then((Response) => {
                dataUrlToFile(Response.data)
            })
        }
    }, [])

    const getBasicPermitView = () => {
        let formFieldValue = {}
        // console.log(ExportBasicDetail, "GetBasicDetail")
        formFieldValue = ExportBasicDetail
        BasicPermitInsertForm.setFieldsValue({
            DescriptionOfWork: formFieldValue.jobDescription,
            Plant: formFieldValue.plant,
            Area: formFieldValue.area,
            MentionArea: formFieldValue.mentionArea === null ? "" : formFieldValue.mentionArea !== "" ? formFieldValue.mentionArea : "",
            department: formFieldValue.departmentName,
            Name: formFieldValue.name,
            NameofPersons: formFieldValue.nameofPersons,
            IssueDate: moment(new Date(formFieldValue.issueDate)).format("DD/MM/yyyy"),
            IssueStartTime: moment(new Date(formFieldValue.issueStartTime)).format("hh:mm"),
            IssueEndTime: moment(new Date(formFieldValue.issueEndTime)).format("hh:mm"),
            ToDepartment: formFieldValue.allotedToDepartment,
            ContractorName: formFieldValue.nameofEmployee,
            NumberOfPersons: formFieldValue.numberofPersons,
        })
    }

    const getPermitMasterMenu = (data) => {
        let divisionID = data.divisionID
        let URL = process.env.REACT_APP_PERMIT + "/Master/GetPermitBasedonDevison?Devison=" + divisionID
        axios.get(URL).then((Response) => {
            setPermitMasterMenu(Response.data)
        }).catch((Error) => {
            console.log(Error, "Error GetNatureofwork")
        })
    }

    const onPermitMasterChange = (data) => {
        let Datas = data.split(/[.\-_]/)
        let value = "";
        value = parseInt(Datas[0]);
        setSelectPermitId(value)
        let PermitName = "";
        PermitName = Datas[1]
        let URL = process.env.REACT_APP_PERMIT + "/Master/GetPermitMasterMenuHierrachy?PermitID=" + value
        axios.get(URL).then((Res) => {
            if (Res.status === 200) {
                var permit = Res.data.map(item => {
                    if (item.type === "bool") {
                        item.value = item.value.toLowerCase() === "false" ? false : true;
                    }
                    if (item.children && item.children.length > 0) {
                        item.children.forEach(child => {
                            if (child.type === "bool") {
                                child.value = child.value.toLowerCase() === "false" ? false : true;
                            }
                        });
                    }
                    return item;
                })
                // console.log(permit, "PermitMaterDetail")
                setPermitMaterDetail(permit)
            } else {
                alert("No Data")
            }

        })
    }

    const handlePermitChange = (e, data, CheckStatus) => {
        let PermiValue = []
        if (CheckStatus === "parent") {
            PermiValue = PermitMaterDetail.map(item => {
                if (item.menuID === Math.floor(data)) {
                    return { ...item, value: e }
                } else {
                    return { ...item }
                }
            })
        } else {
            PermiValue = PermitMaterDetail.map(item => {
                if (item.menuID === Math.floor(data)) {
                    return {
                        ...item, children: item.children.map((C_item) => {
                            if (C_item.menuID === data) {
                                return { ...C_item, value: e }
                            }
                            else {
                                return { ...C_item }
                            }
                        })
                    }
                } else {
                    return { ...item }
                }
            })
        }
        setPermitMaterDetail(PermiValue)
    }

    const handlePermitCheckBoxChange = (e, data, CheckStatus) => {
        let PermiValue = []
        if (CheckStatus === "parent") {
            PermiValue = PermitMaterDetail.map(item => {
                if (item.menuID === Math.floor(data)) {
                    return { ...item, value: e }
                } else {
                    return { ...item }
                }
            })
        }
        else {
            PermiValue = PermitMaterDetail.map(item => {
                let ChildSet = []
                if (item.menuID === Math.floor(data)) {
                    ChildSet = item.children.map((C_item) => {
                        if (C_item.menuID === data) {
                            return { ...C_item, value: !e }
                        }
                        else {
                            return { ...C_item }
                        }
                    })
                    return { ...item, value: (ChildSet.map((item) => item.value)).includes(true), children: ChildSet }
                } else {
                    return { ...item }
                }
            })
        }
        setPermitMaterDetail(PermiValue)
    };

    const onChangeCheck = (e, data, CheckStatus) => {
        let PermiValue = []
        if (CheckStatus === "parent") {
            PermiValue = PermitMaterDetail.map(item => {
                if (item.menuID === Math.floor(data)) {
                    return { ...item, isApplicable: e }
                } else {
                    return { ...item }
                }
            })
        } else {
            PermiValue = PermitMaterDetail.map(item => {
                if (item.menuID === Math.floor(data)) {
                    const updatedChildren = item.children.map((C_item) => {
                        return { ...C_item, isApplicable: null }
                    })
                    return { ...item, value: (updatedChildren.map((child) => child.value)).includes(true), children: updatedChildren }
                } else {
                    return { ...item }
                }
            })
        }
        setPermitMaterDetail(PermiValue);
    }

    const handleDropDownChange = (e, data, CheckStatus) => {
        let PermiValue = []
        if (CheckStatus === "parent") {
            PermiValue = PermitMaterDetail.map(item => {
                if (item.menuID === Math.floor(data)) {
                    return { ...item, value: e }
                } else {
                    return { ...item }
                }
            })
        } else {
            PermiValue = PermitMaterDetail.map(item => {
                if (item.menuID === Math.floor(data)) {
                    return {
                        ...item, children: item.children.map((C_item) => {
                            if (C_item.menuID === data) {
                                return { ...C_item, value: e }
                            }
                            else {
                                return { ...C_item }
                            }
                        })
                    }
                } else {
                    return { ...item }
                }
            })
        }
        setPermitMaterDetail(PermiValue)

    }

    const InsertPermitData = async () => {
        setLoaderHiden(true)
        let basicDetail = {}
        let AttachInputs = [];
        const PermitMateralignData = PermitMaterDetail.reduce((acc, item) => {
            const newItem = { ...item }; // Create a shallow copy of the item
            delete newItem.children; // Remove the 'children' property from the copy
            acc.push(newItem); // Push the modified copy to the result array
            return acc.concat(item.children); // Concatenate children to the result array
        }, []);
        const convertedDatass = PermitMateralignData.map(item => ({
            menuID: item.menuID,
            value: item.value.toString(),
            isApplicable: item.isApplicable
        }));
        for (const FileList of FileLists) {
            let InputData = {};
            InputData.base64 = FileList.url?.split("base64,")[1];
            InputData.fileName = FileList.name;
            AttachInputs.push(InputData);
        }
        basicDetail.basicDetailID = ExportBasicDetail.basicDetailID;
        basicDetail.permitTypeID = SelectPermitId;
        basicDetail.plantID = ExportBasicDetail.plantId
        basicDetail.empid = UserDetails.employeeId;
        basicDetail.menu = convertedDatass;
        basicDetail.images = AttachInputs

        let URL = process.env.REACT_APP_PERMIT + "/Master/CreatePermitMenuTrans"
        axios.post(URL, basicDetail).then((res) => {
            if (res.status === 200) {
                PermiMasterInsert.resetFields()
                toast.success("Permit Detail Saved Successfully")
                Navigate("/BasicPermit");
            } else {
                setLoaderHiden(false)
                toast.error(res.data)
            }
        }).catch((Error) => {
            setLoaderHiden(false)
            console.log(Error, "Error Insert_PRRequest")
        })
    }

    const UpdatePermitData = () => {
        setLoaderHiden(true)
        let UpdatePermitDetail = {}
        let AttachInputs = [];
        const PermitMateralignData = PermitMaterDetail.reduce((acc, item) => {
            const newItem = { ...item }; // Create a shallow copy of the item
            delete newItem.children; // Remove the 'children' property from the copy
            acc.push(newItem); // Push the modified copy to the result array
            return acc.concat(item.children); // Concatenate children to the result array
        }, []);
        const convertedDatass = PermitMateralignData.map(item => ({
            menuID: item.transactionId,
            value: item.value.toString(),
            isApplicable: item.isApplicable
        }));
        for (const FileList of FileLists) {
            let InputData = {};
            InputData.base64 = FileList.url?.split("base64,")[1];
            InputData.fileName = FileList.name;
            AttachInputs.push(InputData);
        }
        UpdatePermitDetail.empid = UserDetails.employeeId;
        UpdatePermitDetail.permitID = ExportPermitImgDetail.permitNumber;
        UpdatePermitDetail.menu = convertedDatass;
        UpdatePermitDetail.images = AttachInputs
        // console.log(convertedDatass, "UpdateConvertedDatas")
        let URL = process.env.REACT_APP_PERMIT + "/Master/UpdatePermit"
        axios.put(URL, UpdatePermitDetail).then((res) => {
            if (res.status === 200) {
                PermiMasterInsert.resetFields()
                toast.success("Permit Detail Updated Successfully")
                const reloadDelay = 500;
                setTimeout(() => {
                    Navigate("/ViewApprovalPage");
                    window.location.reload();
                }, reloadDelay);
            } else {
                setLoaderHiden(false)
                toast.error(res.data)
            }
        }).catch((Error) => {
            setLoaderHiden(false)
            console.log(Error, "Error Insert_PRRequest")
        })
    }

    const ClearPermitData = () => {
        Navigate("/BasicPermit");
    }

    const ClearApprovePermit = () => {
        Navigate("/ViewApprovalPage");
    }

    const onFileUplode = async (file) => {
        if (file.fileList.length > 0) {
            let base64Image = await getBase64(file.file.originFileObj)
            let fileName = file.file.name
            setFileList([...FileLists, {
                uid: file.uid,
                name: fileName,
                status: 'done',
                url: base64Image,
            }])
        }
        else {
            setFileList([])
        }
    }

    const getBase64 = (FileLists) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(FileLists);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const dataUrlToFile = (images) => {
        const files = images.map(
            (row, index) => {
                return {
                    uid: row.id ?? index,
                    name: "FileName" + index + ".jpeg",
                    status: 'done',
                    url: ("data:image/*;base64," + row.image),
                }
            }
        )
        setFileList(files)
        PermiMasterInsert.setFieldValue("AttachmentFile", files)
    }

    const onRemoveFile = (file) => {
        setFileList((prevFileList) => prevFileList.filter((item) => item.uid !== file.uid));
        if (PermiMasterInsert) {
            PermiMasterInsert.setFieldValue('AttachmentFile', (prevFileList) => prevFileList.filter((item) => item.uid !== file.uid));
        }
        return true;
    }

    const fetchData = async (data) => {
        try {
            let divisionID = "";
            divisionID = UserDetails.divisionID
            let PlantID = "";
            PlantID = ExportBasicDetail.plantId
            let UpdatePermitDetail = []
            UpdatePermitDetail = data
            setLoading(true);
            UpdatePermitDetail = data
            let URL = process.env.REACT_APP_PERMIT + "/Master/GetPermitNumberBasedonDivision?Division=" + divisionID + "&Plant=" + PlantID
            const response = await axios.post(URL, UpdatePermitDetail)
            if (response.data !== "") {
                setData(response.data);
                setLoading(false);
            }

        } catch (error) {
            console.error("Error fetching data: ", error);
        }
    };

    const handleFocus = (data) => {
        fetchData(data);
    };

    return (
        <>
            <div className='PermitMainClass'>
                {LoaderHiden && <Loader />}
                <div className='HreaderClass'>
                    <h4 className="Heading"> Permit Details </h4>
                </div>
                <div className='card'>
                    <Form form={BasicPermitInsertForm} layout="vertical" >
                        <div className="row">

                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Plant" hasFeedback name={"Plant"} >
                                        <Input style={{ width: '100%', background: "white", color: "black" }} disabled />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Area" hasFeedback name={"Area"} >
                                        <Input style={{ width: '100%', background: "white", color: "black" }} disabled />
                                    </Form.Item>
                                </div>
                            </div>
                            {BasicPermitInsertForm.getFieldValue("MentionArea") && (
                                <div className="col-md-3 col-sm-12">
                                    <div className="FormCard">
                                        <Form.Item label="Mention Area" hasFeedback name={"MentionArea"}>
                                            <Input style={{ width: '100%', background: "white", color: "black" }} disabled />
                                        </Form.Item>
                                    </div>
                                </div>
                            )}
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="department" hasFeedback name={"department"} >
                                        <Input style={{ width: '100%', background: "white", color: "black" }} disabled />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Name" hasFeedback name={"Name"}>
                                        <Input style={{ width: '100%', background: "white", color: "black" }} disabled />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Issue Date" name={"IssueDate"}>
                                        <Input style={{ width: '100%', background: "white", color: "black" }} disabled />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Issue Start Time" name={"IssueStartTime"}>
                                        <Input style={{ width: '100%', background: "white", color: "black" }} disabled />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Issue End Time" name={"IssueEndTime"}>
                                        <Input style={{ width: '100%', background: "white", color: "black" }} disabled />
                                    </Form.Item>
                                </div>
                            </div>

                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Contractor Name" name={"ContractorName"}>
                                        <Input style={{ width: '100%', background: "white", color: "black" }} disabled />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Number Of Persons" name={"NumberOfPersons"}>
                                        <Input style={{ width: '100%', background: "white", color: "black" }} disabled />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Name of Persons" name={"NameofPersons"} >
                                        <TextArea rows={3} style={{ width: '100%', background: "white", color: "black" }} disabled />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item label="Description Of Work" name={"DescriptionOfWork"} >
                                        <TextArea rows={3} style={{ width: '100%', background: "white", color: "black" }} disabled />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div><br />

                {pathname === "/PermitMaster" &&
                    <>
                        <div className='card'>
                            <div className="row">
                                <div className="col-md-3 col-sm-12">
                                    <div>
                                        <label style={{ color: 'black' }}>{"Type Of Permit :"}</label>
                                        <Select style={{ width: '100%' }} onChange={onPermitMasterChange} placeholder="Select Permit">
                                            {PermitMasterMenu.length > 0 && PermitMasterMenu.map((Item, index) => (
                                                <Select.Option key={index} value={Item.id + "_" + Item.permitType} >
                                                    {Item.permitType}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </div>
                                </div>
                            </div>
                        </div><br />
                    </>
                }

                <Form form={PermiMasterInsert} onFinish={pathname === "/PermitApproverMaster" ? UpdatePermitData : InsertPermitData} >
                    {PermitMaterDetail.length > 0 && PermitMaterDetail.map((item, index) =>
                        <div style={{ borderBottom: "1px solid black", marginLeft: "0%", marginTop: "1%", width: "100%" }} className='row' key={"P_" + index}>
                            <div className='col-md-9'>
                                <div ><b>{index + 1}. </b>{item.title}</div>
                                <div className='row'>
                                    {item.children !== undefined &&
                                        item.children.map((C_item, c_index) => <div className={`col-md-4`} key={"CH_" + c_index + index}>
                                            {C_item.type === "string" && <div>
                                                <div className="FormCard col-md-6">
                                                    <Form.Item label={C_item.title} name={C_item.title} rules={[{ required: false, message: "Enter Value" }]}>
                                                        <Input style={{ width: "100%" }} defaultValue={C_item.value} onChange={(e) => handlePermitChange(e.target.value, C_item.menuID, "Child")} />
                                                    </Form.Item>
                                                </div>
                                            </div>}
                                            {C_item.type === "bool" && <div>
                                                <div className="FormCard col-md-6 flex flex-col">
                                                    <Form.Item name={C_item.title} rules={[{ required: false, message: "Enter Value" }]}>
                                                        <Checkbox checked={C_item.value} key={"CH_" + c_index + index}
                                                            onChange={(e) => handlePermitCheckBoxChange(C_item.value, C_item.menuID, "Child")}>{C_item.title}</Checkbox>
                                                    </Form.Item>
                                                </div>
                                            </div>}

                                            {C_item.type === "dropdown" && <div>
                                                <div className="FormCard col-md-6 flex flex-col">
                                                    <Form.Item name={C_item.title} rules={[{ required: false, message: "Select Value" }]}>
                                                        <Select style={{ width: "100%" }} placeholder="Select Permit"
                                                            onFocus={() => handleFocus(C_item.valuePermitID)}
                                                            onChange={(e) => handleDropDownChange(e, C_item.menuID, "Child")}
                                                            defaultValue={C_item.value}
                                                            notFoundContent={loading ? <Spin size="small" /> : null} >
                                                            {data.length > 0 && data.map((Item, index) => (
                                                                <Select.Option key={index} value={Item}  >
                                                                    {Item}
                                                                </Select.Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </div>
                                            </div>}
                                            {C_item.type === "multidropdown" && <div>
                                                <div className="FormCard col-md-6 flex flex-col">
                                                    <Form.Item name={C_item.title} rules={[{ required: false, message: "Select Value" }]}>
                                                        <Select style={{ width: "100%" }} placeholder="Select Permit" onFocus={() => handleFocus(C_item.valuePermitID)} notFoundContent={loading ? <Spin size="small" /> : null}>
                                                            {data.length > 0 && data.map((Item, index) => (
                                                                <Select.Option key={index} value={Item} >
                                                                    {Item}
                                                                </Select.Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </div>
                                            </div>}
                                        </div>)}
                                </div>

                            </div>
                            <div className='col-md-3'>
                                <div className='row'>
                                    {item.type === "string" && <div>
                                        <div className="FormCard col-md-6">
                                            <Form.Item name={item.title} rules={[{ required: false, message: "Enter Value" }]}>
                                                <Input style={{ width: "150px" }} defaultValue={item.value} onChange={(e) => handlePermitChange(e.target.value, item.menuID, "parent")} />
                                            </Form.Item>
                                        </div>
                                    </div>}
                                    {item.type === "text" && <div>
                                        <div className="FormCard col-md-6">
                                            <Form.Item name={item.title} rules={[{ required: false, message: "Enter Value" }]}>
                                                <TextArea style={{ width: "100%" }} defaultValue={item.value} onChange={(e) => handlePermitChange(e.target.value, item.menuID, "parent")} />
                                            </Form.Item>
                                        </div>
                                    </div>}

                                    {item.type === "bool" && (
                                        <div>
                                            <div className="FormCard col-md-12" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                {item.children !== undefined && item.children.length > 0 ? (
                                                    ""
                                                ) : (
                                                    <Form.Item name={item.title} rules={[{ required: false, message: "Enter Value" }]}>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <a>Yes</a>
                                                            <Switch
                                                                checkedChildren={<CheckOutlined />}
                                                                unCheckedChildren={<CloseOutlined />}
                                                                checked={item.value}
                                                                size="small"
                                                                onChange={() => handlePermitCheckBoxChange(!item.value, item.menuID, "parent")}
                                                                style={{ margin: '0 10px' }} // Add some space between the switch and labels
                                                            />
                                                            <a>No</a>
                                                        </div>
                                                    </Form.Item>
                                                )}
                                                <Form.Item name={item.title} rules={[{ required: false, message: "Select Check" }]}>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Checkbox
                                                            checked={item.isApplicable}
                                                            onChange={() => onChangeCheck(!item.isApplicable, item.menuID, "parent")}
                                                            style={{ marginLeft: '10px' }}
                                                        >
                                                            NA
                                                        </Checkbox>
                                                    </div>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                    )}
                    <Form.Item name={"AttachmentFile"} style={{ marginTop: "1%" }} label={"Attachment File"} rules={[{ required: true, message: 'Attachment File is Required' }]} type="file">
                        <Upload
                            multiple={true}
                            listType="picture-card"
                            onRemove={onRemoveFile}
                            onChange={(e) => onFileUplode(e)}
                            accept="image/png, image/jpeg, image/jpg"
                            fileList={FileLists}
                        >
                            <div>
                                <UploadOutlined />
                                <div style={{ marginTop: 8 }}>Upload</div>
                            </div>
                        </Upload>
                    </Form.Item>
                    {pathname === "/PermitApproverMaster" ?
                        <div className="col-md-12 col-sm-12">
                            <Form.Item className="FormButton" >
                                <Button type='primary' danger onClick={ClearApprovePermit}>Cancel</Button>&nbsp;
                                <Button type='primary' htmlType="submit" >Update</Button>
                            </Form.Item>
                        </div> :

                        <div className="col-md-12 col-sm-12">
                            <Form.Item className="FormButton" >
                                <Button type='primary' danger onClick={ClearPermitData}>Cancel</Button>&nbsp;
                                <Button type='primary' htmlType="submit" disabled={!SelectPermitId > 0}>Submit</Button>
                            </Form.Item>
                        </div>
                    }
                </Form>
            </div>
            <div>
            </div>
        </>
    )
}
export default PermitMasterDetail;